export const comboPackages = [
    117,
    88,
    336,
    566,
    567,
    437,
    647,
    700,
    724,
    813,
    812,
    811,
    810,
    809,
    808
]